export default __webpack_public_path__ + "static/media/2149.1e56f94b.png";